module.exports = __webpack_public_path__ + "img/cash-clock.c3f5b19e.svg";